import type { OrderFinancialSummary } from "../api/catalog-types";

export function orderFinancialRows(
  summary: OrderFinancialSummary | null | undefined,
  totals: { netMinor: number; taxMinor: number; totalMinor: number },
  ar: boolean
) {
  // Old stored responses/documents may lack the additive projection. Show their
  // authoritative net/VAT/total without interpreting their mixed-basis Subtotal.
  const rows = summary ? [
    { key: "items-before-tax", label: ar ? "مجموع الأصناف قبل الضريبة" : "Items before tax", amountMinor: summary.itemsBeforeTaxMinor },
    { key: "delivery-fee", label: ar ? "رسوم التوصيل قبل الضريبة" : "Delivery fee before tax", amountMinor: summary.deliveryFeeBeforeTaxMinor },
    { key: "discount-before-tax", label: ar ? "الخصم قبل الضريبة" : "Discount before tax", amountMinor: 0 - summary.discountBeforeTaxMinor }
  ] : [];
  return [...rows,
    { key: "net-before-tax", label: ar ? "المجموع الإجمالي قبل الضريبة" : "Total before tax", amountMinor: totals.netMinor },
    { key: "tax", label: ar ? "إجمالي الضريبة" : "Total tax", amountMinor: totals.taxMinor },
    { key: "total", label: ar ? "الإجمالي شامل الضريبة" : "Total including tax", amountMinor: totals.totalMinor }
  ];
}
